import SFetch from '@app/utils/sfetch'

window.openFirmTemplateModal = function (
  type,
  buttonElement,
  url,
  companiesCount
) {
  const formElement =
    buttonElement.closest('form') ||
    document.getElementById(buttonElement.dataset.formId)

  if (type === 'firmCompanyTemplate') {
    // firm company template confirmation modal flow
    if (window.triggerTemplateUsagePreview) {
      window.triggerTemplateUsagePreview(formElement, url).then((response) => {
        const selectedMarketPackageNames = response.paidMarketPackagesUsed || []
        const selectedContentNames = response.addedContentNames || []

        if (selectedContentNames.length > 0) {
          window.modalCitizen.openModalPortal(
            'enable-market-package-firm-confirmation-modal',
            {
              companiesCount: companiesCount,
              marketPackageNames: selectedMarketPackageNames,
              formElement: formElement,
              isTriggerCompanyTemplate: true,
              selectedContentNames: selectedContentNames,
            }
          )
        } else {
          formElement.submit()
          return
        }
      })
    }
  } else {
    // firm workflow confirmation modal flow
    // Get selected RT IDs from the auto-added dropdown behavior
    let selectedRtIds = []
    let initialRtIds = []

    if (window.getSelectedRtIds) {
      selectedRtIds = window.getSelectedRtIds()
    }
    if (window.getInitialRtIds) {
      initialRtIds = window.getInitialRtIds()
    }

    const addedRtIds = selectedRtIds.filter((rt) => !initialRtIds.includes(rt))

    if (addedRtIds.length === 0) {
      // If no RTs are selected, just submit the form
      formElement.submit()
      return
    }
    const apiParams =
      selectedRtIds.length > 0 ? `?selected_rts=${selectedRtIds.join(',')}` : ''

    SFetch.json(url + apiParams, { method: 'GET' }).then((response) => {
      // Open the modal with the current market package names
      window.modalCitizen.openModalPortal(
        'enable-market-package-firm-confirmation-modal',
        {
          companiesCount: companiesCount,
          marketPackageNames: response,
          formElement: formElement,
        }
      )
    })
  }
}
